import { faInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { useTranslation } from 'next-i18next';
import { Meetingroom } from '../../../../interfaces/interfaces';
import { useSelector } from '../../../../reduxToolkit/typedRedux';
import VyTooltip from '../../../common/VyTooltip';
import { PresentationInfos } from './PresentationInfos';

interface PresenationInfosButtonProps {
  meetingroom: Meetingroom;
  useAnimatedIconBtn?: boolean; //UI Workaround for presentationCard
  color?: string; // color of the icon default is white
}

const PresenationInfosButton = (props: PresenationInfosButtonProps) => {
  const { meetingroom, useAnimatedIconBtn = false, color = 'white' } = props;

  const event = useSelector((state) => state.common.event || state.admin.event);

  const { t } = useTranslation();

  const [presenationInfoModal, setPresenationInfoModal] = useState<Meetingroom | undefined>();

  if (!event) return null;
  return (
    <>
      <VyTooltip title={t('account:presentation.details')}>
        {useAnimatedIconBtn ? (
          <FontAwesomeIcon
            style={{ marginLeft: '0.5rem', marginRight: '0.5rem' }}
            icon={faInfo}
            color={color}
            className="cursor-pointer"
            onClick={() => setPresenationInfoModal(meetingroom)}
          />
        ) : (
          <div
            onClick={() => setPresenationInfoModal(meetingroom)}
            className="flex items-center justify-center w-10 h-10 rounded-full opacity-75 cursor-pointer bg-slate-700 hover:opacity-100">
            <FontAwesomeIcon icon={faInfo} color={color} />
          </div>
        )}
      </VyTooltip>
      {presenationInfoModal && (
        <PresentationInfos
          presentationId={meetingroom._id}
          onCloseModal={() => {
            setPresenationInfoModal(undefined);
          }}
        />
      )}
    </>
  );
};

export default PresenationInfosButton;
